import { render, staticRenderFns } from "./weiboLabel.vue?vue&type=template&id=554b93f6&scoped=true"
import script from "./weiboLabel.vue?vue&type=script&lang=js"
export * from "./weiboLabel.vue?vue&type=script&lang=js"
import style0 from "./weiboLabel.vue?vue&type=style&index=0&id=554b93f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b93f6",
  null
  
)

export default component.exports